import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import BackButton from '../COMPONENTS/BackButton';
import { Background } from '../COMPONENTS/Background';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import ContactButton from '../../HOME/COMPONENTS/ContactButton';
import HelpIcon1 from '../COMPONENTS/HelpIcon1';
import HelpIcon2 from '../COMPONENTS/HelpIcon2';
import { GAME_PAGE, START_PAGE, YOUTUBE } from '../../HOME/const';
import { goToPage } from '../../HOME/REDUX/actions';
import { setHelped } from '../REDUX/actions';
import { HELPED_KEY, YOUTUBE_TM } from '../const';
import PlayIcon from '../../HOME/SVG/PlayIcon';
import { scrollClass, dbget, dbset } from '../../HOME/utils';

class HelpPage extends Component {
  state = {};

  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);

    const { fromPage, size } = this.props;

    if (fromPage === START_PAGE && size) {
      dbget(HELPED_KEY, response => this.setState({ play: !response }));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    dbset(HELPED_KEY, true);
    this.props.setHelped();
  }

  render() {
    return (
      <div className="page-root tm-page" style={{ backgroundImage: Background }}>
        <div className={scrollClass} style={{ margin: '25px 10px 55px' }}>
          <div className="tm-help-content">
            <div>
              Place three-square blocks ("triominos") on the grid. Tap on any of the green dots to indicate where the next triomino should be
              centered:
            </div>
            <div style={{ justifySelf: 'center', margin: '1em 0' }}>
              <HelpIcon1 width="100px" />
            </div>
            <div>
              Try not to run out of space for as long as possible. Strategically place identically colored squares next to each other to clear
              the grid:
            </div>
            <div className="tm-help-exibit2">
              <HelpIcon2 width="130" style={{ gridArea: '1/1' }} />
              <span style={{ margin: '0 10px', fontSize: '1.5em' }}>=</span>
              <HelpIcon2 opacity="0" width="130" style={{ gridArea: '1/3' }} />
            </div>
            <div>Score a point for each cleared cell. Good luck!</div>
          </div>
        </div>
        {this.state.play && (
          <span className="navigation-button" style={{ left: 'initial', right: '10px' }} onClick={() => this.props.goToPage(GAME_PAGE)}>
            <PlayIcon width="36" color="white" />
          </span>
        )}
        <div className="home-center-button-toolbar">
          <ContactButton size={36} service={YOUTUBE} url={YOUTUBE_TM} />
        </div>
        <BackButton />
        <HomeButton />
      </div>
    );
  }
}

function mapStateToProps({ tm, common }) {
  return { ...tm, ...common };
}

export default connect(
  mapStateToProps,
  { goToPage, setHelped }
)(HelpPage);
